import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import { Link } from 'react-router-dom';
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
} from 'reactstrap';
import Avatar from 'react-avatar';
import { logout } from '../../store';
import { get, isEmpty, map, split } from 'lodash-es';
import { useFetchCorporateGroups } from 'utils/queries/corporate';
import { Select } from 'antd';

const cookies = new Cookies();

const AdminNavbar = ({ accountInfo }) => {
  const [showProfilePicture, setShowProfilePicture] = useState(true);
  const [corporates, setCorporates] = useState('');
  const [selectedCorporate, setSelectedCorporate] = useState('');
  const { data: groups = [] } = useFetchCorporateGroups(
    accountInfo?.user?.IS_CORPORATE_ADMIN,
  );
  useEffect(() => {
    if (accountInfo?.user?.corporates?.length > 0) {
      const cookieCorporate = cookies.get('corporate');
      const hasSavedCorporate = accountInfo?.user?.corporates?.filter(
        (c) => cookieCorporate === c.ID,
      );
      hasSavedCorporate?.length > 0
        ? setSelectedCorporate(cookieCorporate)
        : setSelectedCorporate(accountInfo?.user?.corporates[0]?.ID);
      setCorporates(accountInfo?.user?.corporates);
    }
  }, [accountInfo]);

  const getGroupTitle = () => {
    let groupsLabel = '';
    if (groups?.data?.length > 0) {
      groupsLabel += map(groups?.data, (g) => g?.NAME);
    }
    return (
      <div>
        <strong>Group Admin: </strong>
        {groupsLabel}
      </div>
    );
  };

  const getCorporateDD = () => {
    return (
      <div>
        <strong> Corporate: </strong>
        <Select
          name="corporates"
          value={selectedCorporate}
          onSelect={(value) => {
            onSelectCorporate(value);
          }}
          style={{ minWidth: 150, marginLeft: 5 }}
        >
          {corporates.map((c) => {
            return (
              <Select.Option  key={c.ID} value={c.ID}>
                {c.CORPORATE_NAME}
              </Select.Option>
              // <option key={c.ID} value={c.ID}>
              //   {c.CORPORATE_NAME}
              // </option>
            );
          })}
        </Select>
      </div>
    );
  };

  const onSelectCorporate = (corporateID) => {
    setSelectedCorporate(corporateID);
    document.cookie = 'corporate=' + corporateID + '; path=/';
    window.location.reload(false);
  };
  return (
    <Navbar
      className="navbar-top navbar-dark"
      expand="md"
      id="navbar-main"
      style={{
        backgroundColor: 'white',
        borderBottom: '1px solid #dedee1',
        paddingTop: '10px',
        paddingBottom: '10px',
      }}
    >
      <Container fluid>
        {corporates?.length > 0 && getCorporateDD()}
        {groups?.data?.length > 0 && getGroupTitle()}

        <Link
          className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
          to="/"
        ></Link>
        <Nav className="align-items-center d-none d-md-flex" navbar>
          <UncontrolledDropdown nav>
            <DropdownToggle className="pr-0" nav>
              <Media className="align-items-center">
                {get(accountInfo, 'user.IMAGE') && showProfilePicture ? (
                  <img
                    src={get(accountInfo, 'user.IMAGE')}
                    onError={() => setShowProfilePicture(false)}
                    alt=""
                    style={{
                      objectFit: 'fill',
                      maxWidth: '100%',
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                    }}
                  />
                ) : isEmpty(get(accountInfo, 'user.NAME').trim()) ? (
                  <Avatar
                    size={36}
                    color="rgb(38,117,184, 0.2)"
                    fgColor="#2675b8"
                    round
                    src="https://www.gravatar.com/avatar/00000000000000000000000000000000?d=retro"
                  />
                ) : (
                  <Avatar
                    name={get(accountInfo, 'user.NAME')}
                    size={36}
                    color="rgb(38,117,184, 0.2)"
                    fgColor="#2675b8"
                    round
                  />
                )}
                <Media className="ml-2 d-none d-lg-block">
                  <span
                    className="mb-0 text-sm font-weight-bold"
                    style={{ color: 'black' }}
                  >
                    {isEmpty(get(accountInfo, 'user.NAME').trim())
                      ? get(accountInfo, 'user.PHONE_NUMBER')
                      : split(get(accountInfo, 'user.NAME'), ' ')[0]}
                  </span>
                </Media>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">Welcome!</h6>
              </DropdownItem>
              <DropdownItem to="/admin/myAccount" tag={Link}>
                <i className="ni ni-single-02" />
                <span>My profile</span>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={() => logout()}>
                <i className="ni ni-user-run" />
                <span>Logout</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default AdminNavbar;
